import { render } from "./AppTopbar.vue?vue&type=template&id=2cc4a18a"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=2cc4a18a&lang=css"

import exportComponent from "C:\\Users\\info\\OneDrive\\Desktop\\REPO_MARTECH\\rcstudio-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__